import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { ViewStateTypes } from '@common/enums/viewstate-types';

export class PlanningViewsResults {
    public byGuid: { [id: string]: ViewStateRecord } = {};

    public views: Array<ViewStateRecord> = [];
    public searches: Array<ViewStateRecord> = [];
    public multiviews: Array<ViewStateRecord> = [];

    public add(rec: ViewStateRecord) {
        if (rec.viewStateType === ViewStateTypes.SEARCH || rec.viewStateType === ViewStateTypes.WIRESEARCH || rec.viewStateType === ViewStateTypes.DRAFTSEARCH) {
            this.searches.push(rec);
        } else if (rec.viewStateType === ViewStateTypes.MULTIPLEFEED) {
            this.multiviews.push(rec);
        } else {
            this.views.push(rec);
        }
        this.byGuid[rec.guid] = rec;
    }

    public remove(rec: ViewStateRecord) {
        if (this.byGuid[rec.guid]) {
            delete this.byGuid[rec.guid];
        }

        if (rec.viewStateType === ViewStateTypes.SEARCH) {
            for (let i = 0; i < this.searches.length; i++) {
                if (this.searches[i].guid === rec.guid) {
                    this.searches.splice(i, 1);
                    break;
                }
            }
        } else {
            for (let i = 0; i < this.views.length; i++) {
                if (this.views[i].guid === rec.guid) {
                    this.views.splice(i, 1);
                    break;
                }
            }
        }
    }

    public dispose() {
        this.views = [];
        this.searches = [];
        this.multiviews = [];
        this.byGuid = {};
    }
}
